const zh = {
  onboarding: {
    countryQuestion: "明白了！🌍\n\n你在哪个国家？",
    countryPlaceholder: "你在哪个国家？",
    letsGo: "开始吧！",
    summaryIntro: "🎉 太棒了，{name}！一切准备就绪！",
    yourNameLabel: "你的名字",
    baseLanguageLabel: "基础语言",
    goalsHint: "你可以随时在“目标”页面调整词汇目标和课程时长。",
    startLearning: "开始学习{destLang}！",
  },
  header: {
    learner: "学习者",
    home: "🏠 首页",
    allLessons: "📚 所有课程",
    currentLesson: "📖 当前课程",
    flashcards: "🃏 闪卡",
    progress: "📈 进度",
    goals: "🎯 目标",
    grammarLab: "📘 语法",
    more: "⋯ 更多",
    myVocabulary: "📝 我的词汇",
    listenSpeak: "🎧 听与说",
    signOut: "↩ 退出登录",
  },
  lab: {
    title: "听说实验室",
    back: "返回",
    intro: "就你已经学过的话题，和 Babi 进行一次简短的口语对话。",
    pickTopic: "选择一个你已完成的话题",
    noTopics: "请先完成一节课，然后回到这里练习口语。",
    level: "级别 {level}",
    talkAbout: "和 Babi 聊聊“{topic}”",
    speedLabel: "Babi 的语速",
    speedNormal: "正常",
    speedSlow: "慢速",
    speedNote: "慢速会为同一条回复消耗更多的语音分钟数。",
    startConversation: "开始对话",
    tapToStart: "点击麦克风，用土耳其语回复 Babi。",
    continueConversation: "回答问题",
    finishSession: "结束",
    voiceReviewHint: "检查你说的内容，然后确认——或重新说一次。",
    voiceConfirm: "确认",
    voiceRedo: "重说",
    voiceDenied: "没有麦克风权限，语音不可用。随时点击麦克风图标即可重试。",
    lowBalanceWarning: "本月周期的语音分钟数即将用完。",
    thinking: "Babi 正在思考…",
    complete: "本次练习完成",
    completeSub: "练习得不错。随时回来聊聊其他话题。",
    another: "练习其他话题",
    done: "完成",
    replyError: "Babi 现在无法回复。请稍后再试。",
    tryAgain: "重试",
    eliteUpsellTitle: "「听与说」是 Elite 功能",
    eliteUpsellBody: "你当前是 Pro 套餐。在设置中升级到 Elite，即可和 Babi 练习口语。",
    listenAgainButton: "再听一次",
    listenAgainPlaying: "停止",
    translateButton: "翻译",
    translating: "翻译中…",
    translateFailed: "翻译失败——请重试。",
    starsAriaLabel: "{stars} / 3",
    explainButton: "详细解释",
    explaining: "正在解释…",
    explainFailed: "无法获取解释——请重试。",
    recapHeading: "对话报告",
    recapTitle: "本次总结",
    recapAvgStars: "本次平均分",
    recapTurnsCompleted: "已完成 {completed} / {total} 轮",
    recapErrorFree: "{n} 轮无错误",
    recapMistakesByType: "按类型划分的错误",
    recapCorrections: "已纠正内容",
    voiceMinutesTitle: "语音分钟数",
    voiceMinutesLeft: "本周期剩余 {amount}／共 {total}",
    voiceMinutesNone: "本周期月度语音分钟已用完",
  },
  dashboard: {
    greeting: "你好，{name}！👋",
    streakMsg: "连续学习 {streak} 天 🔥 — 继续加油！",
    noStreak: "今天开始你的第一节课吧！",
    streakProtectionDays: "已获得 {n} 天连续记录保护 🛡️",
    dayInfo: "基础语言：{lang} · 第 {day} 天（共 {total} 天）",
    dayStreak: "天连续",
    share: "分享",
    wordsLearned: "已学单词",
    lessonsDone: "已完成课程",
    goalComplete: "目标完成",
    timeStudied: "学习时长",
    hoursUnit: "小时",
    paceTitle: "📊 每日进度追踪",
    statusAhead: "🚀 领先 {delta} 个单词！",
    statusBehind: "⚡ 需补 {delta} 个单词",
    statusOnTrack: "✅ 进度完全正常！",
    paceTarget: "目标：{wpd} 词/天 · 今天：{today} 词",
    paceExpected: "预期：{n}",
    paceGoal: "目标：{n}",
    actionCurrentLesson: "当前课程",
    actionAllLessons: "所有课程",
    actionFlashcards: "闪卡",
    actionProgress: "我的进度",
    actionGoals: "我的目标",
    actionMyVocabulary: "我的词汇",
    actionGrammarLab: "语法实验室",
    actionListenSpeak: "听说实验室",
    lessonsSub: "{count} 个主题 · {words} 个单词",
    cardsDue: "今天 {n} 张卡片待复习！",
    allCaughtUp: "全部完成！🎉",
    progressSub: "图表、准确率、词汇增长",
    myVocabSub: "浏览你学过的所有单词",
    listenSpeakSub: "和 Babi 练习口语",
    goalsSub: "{words} 词 · {days} 天",
    apiCost: "💰 API 费用追踪",
    since: "自 {date}",
    resetBtn: "↺ 重置",
    totalTokens: "总令牌数",
    inputTokens: "输入",
    outputTokens: "输出",
    estCost: "预计费用",
    apiNote: "claude-sonnet-5 · $3/MTok 输入 · $15/MTok 输出",
    tipLabel: "提示：",
    tips: [
      "在土耳其语中，动词总是位于句末 — «Ben kahve içiyorum» 意思是「我在喝咖啡」。只需吸收这些规律！",
      "土耳其语使用元音和谐 — 后缀的元音要与词根最后一个元音保持一致（如 -lar/-ler，-da/-de）。一旦掌握，一切都豁然开朗！",
      "土耳其语没有语法性别。没有阳性或阴性名词 — 比法语、西班牙语或德语少了一件需要记忆的事！",
      "人称代词（ben = 我，sen = 你）在土耳其语中通常省略，因为动词后缀已经表明了动作执行者。",
      "土耳其语在语音上非常规律 — 每个字母的发音始终相同。读什么就说什么。",
      "否定通过在动词词根后直接添加 -me/-ma 来构成：gel（来）→ gelme（不要来），anla（理解）→ anlama。",
      "土耳其语使用后置词，位于名词之后：«İstanbul'da» = 「在伊斯坦布尔」（伊斯坦布尔 + 位置后缀 -da）。",
      "复数后缀遵循元音和谐：后元音（a, ı, o, u）后用 -lar，前元音（e, i, ö, ü）后用 -ler。",
      "后缀 -ıyor/-iyor/-uyor/-üyor 表示现在进行时。Anlıyorum = 我正在理解（anla + ıyor + um）。",
      "土耳其语复合动词将名词与 etmek（做）或 olmak（是/成为）结合：teşekkür etmek（感谢），hazır olmak（准备好）。",
    ],
  },
  lesson: {
    backBtn: "← 返回",
    topicOf: "第 {order} 个主题，共 {total} 个 · {words} 个单词",
    translating: "正在准备课程…",
    newWords: "✨ 新单词（{n}）",
    alreadyLearned: "🔄 已学过（{n}）",
    practiceDialogue: "🎭 练习",
    generateDialogue: "🎭 给我一个练习对话",
    listenSpeakPractice: "🎧 在听说实验室练习",
    generatingDialogue: "Babi 正在准备对话…",
    newDialogue: "↺ 新对话",
    lessonSaved: "🎉 课程已保存！正在添加 {n} 张新闪卡…",
    alreadyTaken: "✅ 课程已完成",
    markComplete: "✅ 标记课程完成并保存闪卡",
  },
  vocab: {
    structure: "结构",
    loadingExample: "加载中…",
    limitReached: "↺ 已达上限",
    anotherLeft: "↺ 再来一个（剩余 {n} 次）",
    anotherExample: "↺ 另一个例句",
    analyzing: "分析中…",
    analyzed: "✓ 已分析",
    analyzeWord: "🔍 分析单词",
    analysisIntro: "以下是逐步的语法分析:",
    analysisError: "无法加载分析。请重试。",
    reportMistake: "🚩 举报错误",
    reportWrongMeaning: "词义错误",
    reportWrongSentence: "句义错误",
    reportOther: "其他",
    reportChecking: "检查中…",
    reportThanks: "✓ 感谢您帮助我们改进！",
    reportNoIssue: [
      "我在这里没有发现任何问题——在我看来这是正确的！",
      "我没有看到任何问题——这看起来是正确的。",
      "从我的角度来看，一切都没有问题。",
      "我没有发现任何问题；按目前的写法看起来是正确的。",
      "我觉得这看起来不错——我没有任何顾虑。",
      "我检查过了，没有发现需要修改的地方。",
      "我没有发现任何突出的问题；翻译看起来是正确的。",
      "据我所知，一切都是正确的。",
      "我没能发现任何问题；这在我看来没问题。",
    ],
    reportCheckError: "检查未能完成，请稍后再试。",
    reportOkBtn: "好的，我明白了",
    reportEscalateBtn: "转交给人工审核员",
    reportEscalatedMsg: "✓ 已发送给我们的审核团队，谢谢！",
    reportAlreadyFlaggedMsg: "✓ 此内容已提交给我们的审核团队，谢谢！",
  },
  allLessons: {
    title: "📚 所有课程",
    subtitle: "{count} 个主题 · {words} 个单词",
    searchPlaceholder: "🔍 搜索主题或单词…",
    noResults: "没有与\"{search}\"匹配的主题",
    overwhelmedBanner: "您有 {n} 张卡片待复习。请先复习完闪卡，再开始新课程。",
    overwhelmedLock: "请先复习闪卡",
    overwhelmedBtn: "前往闪卡 →",
  },
  flashcards: {
    title: "闪卡",
    cardOf: "第 {current} 张，共 {total} 张",
    tapToReveal: "点击翻转",
    hearIt: "🔊 听发音",
    hearSentence: "🔊 听这个句子",
    allConsolidated: "全部已巩固",
    noDue: "目前没有待复习的卡片。\n你的记忆休息得很好。",
    backToDashboard: "返回仪表板",
    sessionComplete: "本次学习完成",
    memoryRetention: "记忆效率",
    forgotten: "忘记了",
    struggled: "有些难",
    recalled: "想起来了",
    effortless: "轻松记住",
    wordsConsolidated: "{retained}/{total} 个单词已巩固",
    wordsInProgress: "{retained}/{total} 个单词巩固中",
    saveContinue: "保存并继续",
    tomorrow: "明天",
    nDays: "{n}天",
    d1Title: "理解",
    d1SubSkill: "提升阅读和听力技能",
    d1Journey: "新单词从这里开始旅程。",
    d1Due: "{n} 待复习",
    d1Listen: "听发音",
    d1ShowWord: "显示单词",
    d2Title: "产出",
    d2SubSkill: "提升口语和写作技能",
    d2WillStart: "稍后开始",
    d2Empty: "单词在理解闪卡集掌握后进入此处。",
    d2ModalTitle: "产出练习已解锁！",
    d2ModalBody: "这些是您已经能认出的单词。现在我们训练您主动产出它们——这就是从理解{targetLang}到开口说的关键一步。",
    d2ModalBtn: "明白了",
    leaveConfirmTitle: "未保存的复习进度",
    leaveConfirmBody: "您在本次学习中复习的卡片尚未保存。如果现在不保存就离开，这些进度将会丢失。",
    leaveConfirmSave: "保存并离开",
    leaveConfirmDiscard: "放弃并离开",
    leaveConfirmCancel: "取消",
    faq: {
      whyTwoQ: "为什么有两个牌组？",
      whyLaterQ: "为什么输出闪卡集稍后才开始？",
      whyReturnQ: "为什么卡片会不断出现？",
    },
  },
  grammarLab: {
    title: "📘 语法实验室",
    subtitle: "{count} 个可探索的语法要点",
    backBtn: "← 返回",
    searchPlaceholder: "🔍 搜索语法要点…",
    noResults: "没有与\"{search}\"匹配的语法要点",
    allCategories: "所有分类",
    allLevels: "所有等级",
    notReviewedLabel: "未复习",
    reviewedLabel: "已复习",
    dueBadge: "{n} 项待复习",
    explanationLabel: "讲解",
    seeReference: "(见 {term})",
    ruleLabel: "规则",
    formsLabel: "形式",
    translatingNote: "正在翻译成中文...",
    practiceBtn: "▶ 练习该语法点",
    detailedExplanationBtn: "📖 详细讲解",
    practiceTitle: "练习",
    practiceQuestion: "这句话用土耳其语怎么说？",
    practiceOf: "第 {current} 题，共 {total} 题",
    practiceCorrectFeedback: "正确！",
    practiceIncorrectFeedback: "不太对——正确答案是 {answer}。",
    practiceNext: "下一题 →",
    practiceDone: "练习完成",
    practiceScore: "{total} 题中答对 {correct} 题",
    practiceNextReview: "{days} 天后再次复习",
    practiceReset: "这次没通过——明天会再次看到这个语法点。",
    practiceAgainBtn: "再练一次",
    practiceCloseBtn: "完成",
    categories: {
      existential: "存在句式",
      noun_suffix: "名词后缀",
      case_suffix: "格后缀",
      verb_conjugation: "动词变位",
      question_particle: "疑问助词",
      copula: "系词",
      modal_construction: "情态结构",
    },
    points: {
      GP0001: { title: "存在与拥有：var / yok", ruleSummary: "[地点/所有者] + [事物] + var / yok" },
      GP0002: { title: "复数后缀：-ler / -lar", ruleSummary: "名词 + -ler（前元音）/ -lar（后元音）" },
      GP0003: { title: "位格：-de / -da / -te / -ta", ruleSummary: "名词 + -de/-da；清辅音后用 -te/-ta" },
      GP0004: { title: "方向格（与格）：-e / -a", ruleSummary: "名词 + -e/-a；元音后插入缓冲音 -y-" },
      GP0005: { title: "夺格（离格）：-den / -dan / -ten / -tan", ruleSummary: "名词 + -den/-dan；清辅音后用 -ten/-tan" },
      GP0006: { title: "宾格（限定直接宾语）：-i / -ı / -u / -ü", ruleSummary: "名词 + -i/-ı/-u/-ü；元音后加缓冲音 -y-" },
      GP0007: { title: "现在进行时——肯定式：-iyor", ruleSummary: "动词词干 + -iyor + 人称词尾" },
      GP0008: { title: "现在进行时——否定式：-mıyor / -miyor / -muyor / -müyor", ruleSummary: "动词词干 + -mıyor/-miyor/-muyor/-müyor + 人称词尾" },
      GP0009: { title: "现在进行时——疑问式：-iyor mu", ruleSummary: "词干 + -iyor + mu(+人称)；onlar：词干 + -iyorlar + mı" },
      GP0010: { title: "是非疑问助词：mı / mi / mu / mü", ruleSummary: "[词] + 单独书写的助词 mı/mi/mu/mü ?" },
      GP0011: { title: "简单过去时（确知式）：-di / -dı / -du / -dü / -ti / -tı / -tu / -tü", ruleSummary: "动词词干 + -di/-dı/-du/-dü（清辅音后为 -ti/...）+ 人称词尾" },
      GP0012: { title: "系动词'是'的人称词尾（现在时）：-(y)ım, -sin, -ø, -(y)ız, -siniz", ruleSummary: "谓语 + -(y)ım / -sin / -ø / -(y)ız / -siniz / (-lar)" },
      GP0013: { title: "人称领属后缀：我的 / 你的 / 他(她)的 / 我们的 / 你们的 / 他们的", ruleSummary: "(benim/senin/...) 名词 + -im/-in/-i/-imiz/-iniz/-leri" },
      GP0014: { title: "表达愿望：-mek / -mak istemek", ruleSummary: "[不定式 -mek/-mak] + istemek（变位形式）" },
      GP0015: { title: "礼貌请求 / 第二人称复数命令式：-in / -iniz", ruleSummary: "动词词干 + -in/-ın/-un/-ün（礼貌）或 -iniz（更正式）；元音后加缓冲音 -y-" },
    },
  },
  placementTest: {
    title: "🎯 分级测试",
    offerTitle: "已经会一些土耳其语了吗？",
    offerBody: "做一个简短的分级测试——大约20道题——找到你的起始水平。我们会据此调整你的当前课程，但所有主题仍可随时浏览。",
    startBtn: "开始测试",
    notNowBtn: "暂不测试",
    roundLabel: "第 {round} 轮，共 {totalRounds} 轮",
    questionLabel: "第 {n} 题，共 {total} 题",
    wordPrompt: "这个词是什么意思？",
    listeningPrompt: "听录音，选择你听到的单词",
    listeningReplay: "重新播放",
    preparingRound: "正在准备你的问题…",
    finishBtn: "查看我的结果",
    resultsTitle: "你的分级结果",
    resultsLevel: "你被定为 {level} 级",
    resultsBody: "你的当前课程现在从此级别开始。你仍然可以随时在所有课程中浏览更早或更晚的主题。",
    continueBtn: "继续",
  },
  goals: {
    title: "🎯 我的目标",
    displayName: "显示名称",
    namePlaceholder: "你的名字…",
    vocabTarget: "词汇目标",
    words: "词",
    minWords: "最少 1,500",
    midWords: "2,000",
    maxWords: "最多 3,500",
    courseDuration: "目标课程时长",
    months: "个月",
    month: "个月",
    monthsPlural: "个月",
    daysSummary: "= {days} 天",
    baseLanguage: "基础语言",
    otherLanguage: "其他语言（即将推出）",
    selectLanguage: "选择语言…",
    ok: "确定",
    langNames: {
      English: "英语", Farsi: "波斯语", Arabic: "阿拉伯语",
      French: "法语", German: "德语", Spanish: "西班牙语",
      Russian: "俄语", Portuguese: "葡萄牙语", Chinese: "中文",
      Turkish: "土耳其语", Hindi: "印地语", Italian: "意大利语",
    },
    targetLanguage: "目标语言",
    targetLangNames: {
      Turkish: "土耳其语",
    },
    wordsLbl: "词",
    wordsPerDay: "词/天",
    daysLbl: "天",
    saved: "✅ 目标已保存！",
  },
  progress: {
    title: "📈 我的进度",
    memDistTitle: "记忆状态分布 · {n} 张卡片",
    inAcquisition: "习得中",
    rooted: "已扎根",
    fluent: "流利",
    deeplyRetained: "深度记忆",
    acqDesc: "稳定性 < 3 天",
    rootedDesc: "稳定性 3–21 天",
    fluentDesc: "稳定性 21–90 天",
    retainedDesc: "稳定性 90 天以上",
    forecastTitle: "复习预测 — 未来 15 天",
    cardsDue: "待复习卡片",
    today: "今天",
    tmrw: "明天",
    plusDays: "+{n}天",
    todayFull: "今天",
    tmrwFull: "明天",
    plusDaysFull: "+{n}天",
    goalProgress: "总体目标进度",
    wordsLearned: "已学 {learned} / {target} 词",
    vocabGrowth: "词汇增长",
    noChart: "完成第一节课后即可查看图表！📚",
    wordsLearnedSeries: "已学单词",
    topicRings: "主题记忆环",
    quickStats: "快速统计",
    dayStreak: "天连续 🔥",
    lessonsDone: "课程已完成",
    totalStudy: "总学习时长",
    avg14Day: "14天平均",
    minUnit: "分钟",
    dayLabel: "第 {n} 天",
    cards: "张",
  },
  myVocab: {
    title: "📝 我的词汇",
    summaryTitle: "已学习 {n} 个单词",
    searchPlaceholder: "🔍 搜索你的单词…",
    allStatuses: "所有状态",
    noResults: "没有与\"{search}\"匹配的单词",
    noWords: "完成一课以开始积累词汇量！📚",
    completedTopicsTitle: "已完成主题（{n}/{total}）",
    noDate: "—",
  },
  badges: {
    newbie: "新手",
    wordExplorer: "词汇探险家",
    wordNerd: "单词达人",
    wordWizard: "单词魔法师",
    rockstar: "摇滚明星",
    expert: "专家",
    champion: "冠军",
  },
  memStates: {
    inAcquisition: "习得中",
    rooted: "已扎根",
    fluent: "流利",
    deeplyRetained: "深度记忆",
  },
  chat: {
    subtitle: "你的土耳其语导师",
    greetWords: ["嗨", "你好", "亲爱的"],
    greeting: "{greet}{name}，\n\n有关土耳其语的任何问题（语法、词汇、文化）或关于如何使用本应用，都可以问我。",
    placeholder: "问关于土耳其语或应用的问题…",
    error: "抱歉，目前无法连接。请重试。",
    escalationFallback: "抱歉，我无法完全帮你解决这个问题。我已经将此事反馈给我们的团队，你将通过邮件收到回复 — 通常在2个工作日内。你也可以直接通过 support@speafy.com 联系我们。",
    welcome: "你好，{name}！👋 欢迎使用 Speafy！我是巴比，我在这里做两件事：帮你熟悉这个应用，并回答你关于{targetLanguage}的任何问题。\n\n从当前课程开始，或从「所有课程」中选择一个主题。完成后别忘了将每节课标记为已完成，然后复习闪卡。\n\n随时问我——关于应用或关于{targetLanguage}的问题都可以。\n\n祝你学习顺利！😊",
    lessonLimit: "你今天已完成 {limit} 节课 — 太棒了！🌟\n\n为了让学习可持续，避免闪卡队列过长，每天最多学习 {limit} 节课。\n\n给大脑一些时间巩固今天所学。不如来一次闪卡复习吧？\n\n明天我在这里等你！😊",
    streakDecayed: "欢迎回来！👋 你离开了 {days} 天。多亏你已获得的 {protection} 天连续记录保护 🛡️，你的连续记录只从 {oldStreak} 降到了 {newStreak}，而不是完全清零。让我们继续加油吧！",
    streakWiped: "欢迎回来！👋 你离开了 {days} 天 — 超过了你储存的 {protection} 天连续记录保护 🛡️，所以连续记录从 1 重新开始了。每个连续记录都有起点 — 让我们重新开始建立吧！",
    weeklyRecapFallback: "嗨！👋 我本来想给你带来每周总结，但现在整理时遇到了点问题。不过先简单说一句——你已经连续学习了 {streak} 天，继续保持！🔥",
    dailyPlanQuestion1: "嗨！👋 你今天有多少时间可以学习？",
    dailyPlanQuestion2: "你好！😊 我为你准备了一个学习计划——你今天能安排多少分钟？",
    dailyPlanQuestion3: "准备好今天的计划了吗？🎯 告诉我大概有多少时间就行。",
    dailyPlanClarify: "抱歉，我没太理解！能给我一个大概的数字吗，比如“20”或“30分钟”？",
    dailyPlanUnreasonable: "这听起来不太像一次典型的学习时间！能告诉我一个在5分钟到5小时之间的数字吗？",
    dailyPlanGiveUp: "没关系——准备好了随时去闪卡或当前课程开始学习吧！😊",
    dailyPlanFallback: "我已经记下了你的可用时间，但现在制定今天的计划时遇到了点问题。与此同时，如果你有到期的卡片，闪卡始终是个不错的选择！😊",
    sendBtn: "发送",
    askBabi: "问 Babi",
    voiceConsentTitle: "开启与 Babi 的语音聊天？",
    voiceConsentBody: "Babi 会使用你的麦克风来聆听你说话，并用扬声器回复你。你的语音会被转换成文字——音频录音本身永远不会被保留。文字最多可保留30天。详情请参阅我们的隐私政策。",
    voiceConsentPrivacyLink: "隐私政策",
    voiceConsentAllow: "允许使用麦克风",
    voiceConsentDecline: "暂不",
    voiceDenied: "没有麦克风权限，语音聊天不可用。你仍然可以通过打字继续聊天——随时点击麦克风图标即可重试。",
    voiceDeviceInUse: "你的麦克风似乎正被其他地方占用——请关闭正在使用它的其他应用后重试。",
    voiceError: "语音聊天出了点问题，请重试。",
    voiceStarting: "正在启动…请稍候",
    voiceListening: "正在聆听…",
    voiceProcessing: "正在理解…",
    voiceReviewHint: "点击可编辑，否则将在几秒后自动发送。",
    voiceSendNow: "立即发送",
    voiceDiscard: "放弃",
    voiceEditTranscript: "编辑 Babi 听到的内容",
    voiceBadgeLabel: "通过语音发送",
    voiceDidntCatch: "没听清楚——点击麦克风重试。",
    voiceSpeaking: "Babi 正在说话…",
    voiceTtsUnavailable: "该回复暂无语音——改为显示文字。",
    voiceTtsUnavailableLanguage: "Babi 的语音回复暂不支持{language}。",
    voiceTapToHear: "点击收听 Babi 的回复",
    voiceNotEntitled: "与 Babi 语音聊天是高级功能——升级后即可使用。",
    voiceNoBalance: "你本周期的语音分钟数已用完，将在下个周期刷新。",
    voiceOtherTabActive: "语音聊天已在另一个标签页中启用。",
    voiceLowBalanceNudge: "本周期的语音分钟数即将用完。",
    voiceLowMinutesHeadsUp: "本周期的语音分钟数即将用完。",
    voiceGetMoreMinutes: "获取更多分钟数",
    voiceStopBtn: "停止",
    voiceMicButtonLabel: "语音聊天",
    voiceBannerDismiss: "关闭",
  },
  settings: {
    title: "设置",
    accountSection: "账户",
    linkedGoogle: "已关联 Google",
    emailAccountBadge: "邮箱账户",
    changeNameBtn: "更改用户名",
    nameSaveBtn: "保存",
    nameCancelBtn: "取消",
    nameSaving: "保存中…",
    passwordLabel: "密码",
    passwordSub: "发送重置链接到你的邮箱",
    passwordSent: "已发送 ✓",
    passwordResetBtn: "重置",
    subscriptionSection: "订阅",
    subscriptionAdminLabel: "管理员账户",
    subscriptionAdminSub: "您拥有所有功能的完整、永久使用权限。",
    subscriptionReviewerLabel: "评测员访问权限",
    subscriptionReviewerSub: "作为应用评测员,您可以免费使用所有功能。",
    subscriptionProPlan: "Speafy Pro — {plan}",
    subscriptionElitePlan: "Speafy Elite — {plan}",
    subscriptionPlanAnnual: "年付",
    subscriptionPlanMonthly: "月付",
    subscriptionRenews: "将于 {date} 续订",
    subscriptionActive: "已激活",
    subscriptionManageLink: "账单与发票",
    subscriptionCancelLink: "取消或暂停订阅",
    subscriptionPaymentFailedLabel: "您上次的付款失败了",
    subscriptionPaymentFailedSub: "付款于 {date} 失败",
    subscriptionPaymentFailedSubNoDate: "请更新您的付款方式以保留 Pro 权限",
    subscriptionUpdatePaymentLink: "更新付款方式 ↗",
    subscriptionCancelledPending: "您的订阅将于 {date} 结束 — 在此之前您仍可使用 Pro 权限",
    subscriptionPausedLabel: "订阅已暂停",
    subscriptionPausedSub: "将于 {date} 自动恢复 — 除非您提前恢复，否则将收取新周期的全额费用",
    subscriptionPausedSubNoDate: "将在 3 个月后自动恢复，除非您提前恢复",
    subscriptionResumeBtn: "立即恢复",
    subscriptionResuming: "正在恢复…",
    pausePendingLabel: "已安排暂停",
    pausePendingSub: "将于 {date}（当前计费周期结束时）生效",
    manageOfferTitle: "正在考虑取消订阅吗？",
    manageOfferSub: "不如暂停订阅——您可以保留进度直到 {date}，之后订阅将在 3 个月后自动恢复，并收取新周期的全额费用，除非您提前恢复。",
    manageOfferPauseBtn: "改为暂停",
    manageOfferContinueLink: "仍然取消",
    manageOfferDismiss: "算了",
    pauseOfferLabel: "需要休息一下吗？",
    pauseOfferSub: "暂停订阅 3 个月，而不是取消 — 保留您的学习进度，随时可恢复。",
    pauseOfferBtn: "暂停订阅",
    pauseConfirmP1: "暂停您的 Speafy Pro 订阅？",
    pauseConfirmC1: "您当前的计费周期将持续到 {date} — 您已支付的内容都会保留。",
    pauseConfirmC2: "暂停期间，新课程将被锁定（与免费试用到期时相同），但您仍可正常复习已有的记忆卡。",
    pauseConfirmC3: "暂停固定持续 3 个月。如果您在此之前未手动恢复，订阅将自动恢复，并按新周期收取全额费用。",
    pauseConfirmBtn: "确认暂停",
    pausing: "正在暂停…",
    pauseFailedGeneric: "暂停订阅时出错。请重试或联系客服。",
    manageLinkLoading: "加载中…",
    manageLinkFailedGeneric: "暂时无法加载管理链接，请重试。",
    resumeConfirmP1: "现在恢复您的 Speafy Pro 订阅？",
    resumeConfirmC1: "系统将立即收取新计费周期的全额费用。",
    resumeConfirmBtn: "是的，立即恢复",
    resumeFailedGeneric: "恢复订阅时出错。请重试或联系客服。",
    subscriptionLastCharge: "最近扣款：{date} {amount} — {status}",
    subscriptionLastChargePaid: "已支付",
    subscriptionLastChargeFailed: "失败",
    tierChangePendingLabel: "套餐变更已安排",
    tierChangePendingToElite: "将于 {date} 切换到 Elite",
    tierChangePendingToBasic: "将于 {date}（当前账单周期结束时）切换到 Pro",
    tierUpgradeToEliteLink: "升级到 Elite",
    tierDowngradeToBasicLink: "切换回 Pro",
    tierUpgradeConfirmTitle: "升级到 Elite？",
    tierUpgradeConfirmSub: "今天将按比例收取差价，您将立即获得 Elite 提供的与 Babi 的 3 小时语音对话 — 此后为 {price}/{interval}。",
    tierDowngradeConfirmTitle: "切换回 Pro？",
    tierDowngradeConfirmSub: "您将保留 Elite 至 {date}，随后在下一个账单日期切换到 Pro — 今天不收费。",
    tierUpgradeConfirmBtn: "是的，立即升级",
    tierDowngradeConfirmBtn: "是的，切换到 Pro",
    tierChangeBusy: "更新中…",
    tierChangeFailedGeneric: "更改套餐时出了点问题。请重试或联系支持团队。",
    voiceMinutesLabel: "语音分钟数（{tier}）",
    voiceTierElite: "Elite",
    voiceTierBasic: "Pro",
    voiceTierTrial: "试用",
    voiceTierAdmin: "管理员",
    voiceTierViewer: "查看者",
    voiceMinutesUsed: "本周期已使用 {used}，共 {limit}",
    voiceMinutesPurchasedExtra: "另有已购买的 {extra}——月度分钟用完后使用，且永不过期",
    yourDataSection: "你的数据",
    marketingLabel: "营销通讯同意",
    marketingSub: "更新、通知和特别优惠",
    voiceConsentLabel: "与 Babi 语音聊天",
    voiceConsentSub: "允许 Babi 听到你的声音并大声回复",
    privacyLegalSection: "隐私、条款与法律信息",
    privacyPolicyLabel: "隐私政策",
    privacyPolicySub: "我们如何收集、使用和保护你的数据",
    viewLink: "查看",
    termsLabel: "服务条款",
    termsSub: "规范你使用行为的规则与条件",
    refundLabel: "退款政策",
    refundSub: "退款资格及申请方式",
    cookieSettingsLabel: "Cookie 设置",
    cookieSettingsSub: "管理分析类和功能类 Cookie",
    manageLink: "管理",
    privacySection: "隐私与数据",
    exportLabel: "导出我的数据",
    exportSub: "下载包含个人资料、进度和闪卡的 JSON 文件",
    exportBtn: "导出",
    exportDone: "✓ 已下载",
    cacheLabel: "本地缓存",
    cacheSub: "学习进度和示例句子已缓存在您的浏览器中以提高速度。",
    cookieLabel: "Cookie 和隐私设置",
    cookieSub: "分析和 Cookie 偏好在 Speafy 网站上管理",
    privacyLink: "隐私政策 ↗",
    aboutSection: "关于",
    aiTutorLabel: "AI 导师",
    aiTutorSub: "由 Claude Sonnet — Anthropic 提供支持",
    algoLabel: "记忆算法",
    algoSub: "FSRS v4.5 — 免费间隔重复调度器",
    learningSection: "学习",
    placementTestLabel: "分级测试",
    placementTestSubNew: "通过快速测试找到你的起始水平",
    placementTestSubRetake: "上次测定等级：{level} · 可随时重新测试",
    placementTestBtnNew: "开始测试",
    placementTestBtnRetake: "重新测试",
    versionLabel: "版本",
    appearanceSection: "外观",
    darkModeLabel: "深色模式",
    darkModeSub: "切换到深色配色方案",
    largeTextLabel: "大字体",
    largeTextSub: "增大文字大小以便于阅读",
    babiCheckinsSection: "Babi 签到提醒",
    babiDailyNudgeLabel: "Babi 的每日提醒",
    babiDailyNudgeSub: "Babi 每天会询问你有多少时间，并建议一个学习计划",
    babiWeeklyReportLabel: "Babi 的每周报告",
    babiWeeklyReportSub: "每周一次的学习进度总结",
    dangerSection: "危险区域",
    resetLabel: "重置所有进度",
    resetSub: "清除您的连续记录、闪卡和课程历史。无法撤消。",
    resetBtn: "重置",
    resetConfirmP1: "重置所有进度？这将永久删除：",
    resetConfirmC1: "全部 {n} 张闪卡及其记忆数据",
    resetConfirmC2: "您的连续记录（{n} 天）和学习历史",
    resetConfirmC3: "您正在学习的每种语言的所有课程完成记录",
    resetConfirmC4: "您在语法实验室的复习进度",
    resetConfirmP2: "您的账户、姓名和语言设置将保留。",
    resetConfirmBtn: "是的，重置一切",
    resetting: "重置中…",
    resetDone: "✅ 进度已重置！从头开始吧。",
    deleteLabel: "删除账户",
    deleteSub: "永久删除您的账户和所有数据。无法撤消。",
    deleteBtn: "删除账户",
    deleteConfirmP1: "永久删除您的 Speafy 账户？这将立即且不可撤销地删除：",
    deleteConfirmC1: "您的个人资料（姓名、语言、目标）",
    deleteConfirmC2: "全部 {n} 张闪卡和记忆数据",
    deleteConfirmC3: "您的完整学习历史和连续记录",
    deleteConfirmC4: "您的 Firebase 身份验证账户",
    deleteConfirmPrompt: "输入 DELETE（全部大写）以确认：",
    deleteConfirmBtn: "永久删除我的账户",
    deleting: "删除中…",
    cancelBtn: "取消",
  },
  trial: {
    daysLeftBadge: "⏱ 剩余{n}天",
    expiredBadge: "试用已结束 · 升级 ↑",
    pausedBadge: "⏸ 已暂停",
    proBadge: "✦ 专业版",
    eliteBadge: "✦ Elite 版",
  },
  paywall: {
    back: "← 返回",
    title: "升级到 Speafy Pro",
    subTrialExpired: "您的免费试用已结束。请升级以继续学习。",
    subDefault: "解锁所有课程和闪卡复习。",
    features: [
      "全部 {count} 课程完全解锁",
      "与AI导师Babi无限聊天",
      "智能FSRS闪卡复习",
      "进度追踪与记忆分析",
      "每个单词的原音音频",
      "练习对话",
      "多语言应用界面",
    ],
    tierPro: "Pro",
    tierElite: "Elite",
    eliteFeatures: [
      "包含 Speafy Pro 的全部内容",
      "听说实验室 — 与 Babi 进行引导式对话练习",
      "每月与 Babi 进行 3 小时语音对话",
      "随时购买额外语音分钟数 — 每小时 $3",
    ],
    billingMonthly: "月付",
    billingYearly: "年付",
    saveBadge: "节省25%",
    pricePerMonth: "/月",
    priceBilledYearly: "按年计费",
    cta: "开始 Speafy Pro →",
    ctaElite: "开始 Speafy Elite →",
    fine: "随时取消 · 通过Paddle安全结账",
    bannerExpired: "您的免费试用已结束。",
    bannerActive: "免费试用 — 剩余{n}天。",
    bannerBtn: "升级 ↑",
    settingsFreePlan: "免费版",
    pausedTitle: "您的订阅已暂停",
    pausedSub: "在设置中恢复订阅即可再次解锁新课程。",
    pausedGoToSettingsBtn: "前往设置",
    alreadyProTitle: "您已经是 Pro 用户！",
    alreadyProSub: "您的订阅已激活 — 无需再次购买。",
    alreadyProGoHomeBtn: "前往首页",
    settingsTrialRemaining: "试用 — 剩余{n}天",
    settingsTrialEnded: "试用已结束 — 升级以解锁所有课程",
    settingsFreeForever: "从上次离开的地方继续——升级以解锁所有课程",
    settingsUpgradeBtn: "升级",
  },
  authAction: {
    verifyingTitle: "正在验证您的邮箱…",
    verifiedTitle: "您的邮箱已验证！",
    verifiedBody: "一切就绪。返回 Speafy 继续学习吧。",
    continueBtn: "继续前往 Speafy →",
    verifyErrorTitle: "此链接已过期",
    verifyErrorBody: "此验证链接已失效。请登录，我们会为您发送一个新的链接。",
    resendBtn: "重新发送验证邮件",
    resendSent: "已发送 ✓",
    resendError: "重新发送失败，请稍后再试。",
    signInBtn: "登录",
    verifyingReset: "正在检查您的链接…",
    resetTitle: "重置密码",
    resetBodyFor: "为 {email} 设置新密码",
    newPasswordPh: "新密码",
    confirmPasswordPh: "确认新密码",
    resetSubmitBtn: "重置密码",
    resettingBtn: "正在重置…",
    resetSuccessTitle: "密码已更新！",
    resetSuccessBody: "您的密码已更改。请使用新密码登录。",
    resetErrorTitle: "此链接已过期",
    resetErrorBody: "此重置密码链接已失效，请在登录页面重新申请一个。",
    passwordMismatch: "两次输入的密码不一致。",
    passwordTooShort: "密码至少需要 6 个字符。",
    genericError: "出了点问题，请重试。",
    invalidTitle: "此链接无效或已过期",
    invalidBody: "您访问的链接已失效，请返回 Speafy 重试。",
    backToSignIn: "返回登录",
  },

  teacherDash: {
    link: "教师面板",
    title: "教师面板",
    backHome: "返回首页",
    studentBadge: "你的老师：{name}",
    intro: "把学生带到 Speafy 并跟进他们进度所需的一切。",
    referralTitle: "你的推荐链接",
    referralBody: "把这个链接分享给你的学生。任何通过该链接注册的人都会被关联为你的学生。",
    copy: "复制链接",
    copied: "已复制",
    studentsTitle: "你的学生",
    studentsLoading: "正在加载你的学生…",
    studentsError: "暂时无法加载你的学生。",
    retry: "重试",
    studentsEmpty: "还没有学生。分享你的推荐链接——通过它加入的学生会显示在这里。",
    colName: "学生",
    colJoined: "加入时间",
    colStatus: "订阅",
    colCommission: "已赚佣金",
    colGrammar: "语法重点",
    statusActive: "有效",
    statusTrial: "试用",
    statusNone: "未订阅",
    commissionNote: "这是你从每位学生那里累计赚取的金额。可申请提现的余额显示在下方。",
    commissionCapReached: "12 个月周期已结束",
    grammarNote: "仅对拥有有效订阅的学生显示语法错误数据。",
    studentUnnamed: "学生",
    curriculumTitle: "课程大纲参考",
    curriculumBody: "按顺序浏览你的学生学习的每个主题和单词。",
    curriculumLink: "打开课程大纲参考",
    profileTitle: "你的教师资料",
    profileBody: "这是 Speafy 教师目录上线后你在其中的显示方式。",
    profileBio: "简短介绍",
    profileBioPh: "用一两句话介绍你自己以及你的教学方式。",
    profilePhoto: "照片",
    photoChoose: "选择照片",
    photoUploading: "上传中…",
    photoRemove: "移除",
    photoHint: "PNG 或 JPG，最大 200 KB。",
    photoTypeErr: "请选择 PNG 或 JPG 图片。",
    photoSizeErr: "该图片超过 200 KB，请选择更小的图片。",
    photoUploadErr: "上传失败，请重试。",
    profileLink: "个人网站或社交媒体链接",
    profileLinkPh: "www.example.com",
    profileLanguages: "我教授的语言",
    profileLanguagesHint: "选择你教授的语言。随着 Speafy 将更多语言加入课程，选项会逐步开放。",
    profileLanguagesSoon: "即将推出",
    save: "保存",
    saving: "正在保存…",
    saved: "已保存",
    urlError: "这看起来不是一个网址。请检查，或将该字段留空。",
    termsStatusAccepted: "教师合作伙伴条款 — 已于 {date} 接受",
    termsStatusPending: "教师合作伙伴条款 — 尚未接受",
    termsVersionLabel: "版本 {version}",
    termsView: "查看已接受的条款",
    payoutTitle: "提现",
    payoutLoading: "正在加载你的提现状态…",
    payoutError: "暂时无法加载你的提现状态。",
    payoutBalance: "你当前的余额：{balance}",
    payoutNotEligible: "余额达到 {threshold} 后，你就可以申请提现了。",
    payoutAlreadyRequested: "提现申请已提交——我们会与你联系。",
    requestPayoutBtn: "申请提现",
    payoutRequestFailed: "提交申请时出了点问题，请重试。",
    payoutConfirmTitle: "申请提现？",
    payoutConfirmBody: "你目前有 {balance} 可供申请。\n\n这将启动人工提现流程——不会自动转账。我们会审核你的申请并通过邮件与你联系。",
    payoutConfirmBtn: "申请提现",
    payoutConfirmCancel: "取消",
  },

  teacherTerms: {
    screenTitle: "教师合作伙伴条款",
    contents: "目录",
    lastUpdatedLabel: "最近更新",
    effectiveLabel: "生效日期",
    bannerTitle: "需要处理",
    bannerBody: "请阅读并接受《教师合作伙伴条款》以继续作为合作伙伴。",
    bannerCta: "查看并接受",
    acceptedOn: "您已于 {date} 接受本条款。",
    acceptedVersion: "已接受版本：{version}",
    accepting: "正在记录您的接受…",
    acceptError: "暂时无法记录您的接受，请重试。",
    draftNotice: "本条款尚未最终确定。生效日期确定后，您即可接受。",
  },
};

export default zh;
